<template>
  <el-dialog
    v-model="visible"
    title="NFC URL列表"
    width="800px"
    destroy-on-close
  >
    <el-table v-loading="loading" :data="tableData">
      <el-table-column prop="name" label="小程序名称" />
      <el-table-column prop="url" label="NFC URL" show-overflow-tooltip />
    </el-table>
  </el-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';

interface TableItem {
  name: string;
  url: string;
}

interface WeappItem {
  appid: string;
  name: string;
}

const visible = ref(false);
const loading = ref(false);
const tableData = ref<TableItem[]>([]);
const currentStoreId = ref<number>(0);

const loadData = async() => {
  try {
    loading.value = true;
    tableData.value = [];

    // 获取小程序列表
    const weappRes = await useApi().weappApi.listWeappweapp({
      conditions: {},
    });
    const weappList = (weappRes.data.data || []) as WeappItem[];

    // 获取每个小程序的NFC URL
    for (const weapp of weappList) {
      try {
        const urlRes = await useApi().storeApi.getNFCUrlstore({
          appid: weapp.appid,
          storeId: currentStoreId.value,
        });

        tableData.value.push({
          name: weapp.name,
          url: urlRes.data.data || '-',
        });
      } catch (error) {
        console.error('获取NFC URL失败:', error);
        tableData.value.push({
          name: weapp.name,
          url: '获取失败',
        });
      }
    }
  } catch (error) {
    console.error('加载数据失败:', error);
    ElMessage.error('加载数据失败');
  } finally {
    loading.value = false;
  }
};

const show = async(storeId: number) => {
  visible.value = true;
  currentStoreId.value = storeId;
  await loadData();
};

defineExpose({
  show,
});
</script>

<style lang="scss" scoped>
</style>
